<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-text">
                    <h2>PROCÉDEZ AU PAIEMENT</h2>
                    <ul>
                        <li><a routerLink="/">ACCUEIL</a></li>
                        <li><i class="icofont-simple-right"></i></li>
                        <li>PROCÉDEZ AU PAIEMENT</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="payment-page pt-100 pb-170">
    <div class="container">
        <div class="payment-content">
            <div class="payment-illustration">
                <img src="assets/guides/04.png" alt="Paiement" class="payment-image" />
            </div>
            
            <div class="payment-info">
                <h4>Procédez au Paiement</h4>
                <p class="payment-description">
                    Cette étape vous permet de procéder au paiement des frais de participation à la qualification QualifPME fixés à <strong>100 000 GNF</strong>.
                </p>
                <p class="payment-benefits">
                    Ces frais vous permettent de participer au processus de qualification et d'accéder à l'évaluation de votre entreprise.
                </p>
                
                <div class="pricing-card">
                    <div class="pricing-header">
                        <span class="pricing-badge">Frais de Participation</span>
                        <div class="pricing-amount">
                            <span class="amount">100 000</span>
                            <span class="currency">GNF</span>
                        </div>
                    </div>
                    <div class="pricing-features">
                        <div class="feature-item">
                            <i class="icofont-check-circled"></i>
                            <span>Accès au processus de qualification</span>
                        </div>
                        <div class="feature-item">
                            <i class="icofont-check-circled"></i>
                            <span>Évaluation complète de votre entreprise</span>
                        </div>
                    </div>
                </div>
                
                <div class="payment-actions">
                    <button routerLink="/company/dashboard" class="btn btn-outline-dark">
                        <i class="icofont-arrow-left"></i>
                        Annuler
                    </button>
                    <button (click)="onPayment()" [disabled]="loading" class="btn btn-primary">
                        <i class="icofont-money"></i>
                        Procéder au Paiement
                        <i class="icofont-arrow-right"></i>
                        <i *ngIf="loading" class="icofont-spinner-alt-1 icofont-spin"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
